import { imageVariantLink } from '@/common/media';
import type {
  ContactChannelResponse,
  PersonContactResponse,
} from '@/store/contacts/contacts.dto.ts';

export const preferredChannel = (
  contact: PersonContactResponse,
): ContactChannelResponse | undefined =>
  contact.contacts?.find(({ contact_type }) => contact_type === 'phone') ??
  contact.contacts?.find(({ contact_type }) => contact_type === 'email');

export const guestContactOptions = (contacts: PersonContactResponse[]) =>
  contacts
    .filter(({ type }) => type === 'person')
    .map((contact) => ({
      value: contact.id,
      personId: contact.contact_id,
      name: contact.name,
      avatar: imageVariantLink(contact.avatar, 28) ?? undefined,
      label: preferredChannel(contact)
        ? contact.name
        : `${contact.name} has no email or phone. Please invite them instead.`,
      disabled: !preferredChannel(contact),
    }));

export const pickedGuestContacts = (contacts: PersonContactResponse[], ids: string[]) =>
  ids.flatMap((id) => {
    const picked = contacts.find((contact) => contact.id === id);
    const channel = picked && preferredChannel(picked);
    return picked && channel
      ? [{ name: picked.name, contact: channel.contact, personId: picked.contact_id }]
      : [];
  });
